import Pagination from "./pagination.component";

export default Pagination;
